
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard.component";
import StrengthWeakness from "../pages/StrengthWeakness";
import StudentPerformance from "../pages/StudentPerformance";
import PageNotFound from "../pages/404Page";
import HumanResources from "../pages/humanResources";
import CollegeCareerReadiness from "../pages/CollegeCareerReadiness";
import StudentBehaviour from "../pages/studentbehaviour";
import GraduationRateAnalysis from "../pages/GraduationRateAnalysis";
import Districtgoals from "../pages/districtgoals";
import Enrollment from "../pages/enrollment";
import Studentbehaviorexecutive from "../pages/studentbehaviorexecutive";
import Schoolperformance from "../pages/schoolperformance";
import Login from '../setup/login'
import StateBenchMarking from "../pages/statebenchmarking";
import AnnualPlanDashboard from "../pages/Annualplandashboard";
import Staffdetails from "../pages/staffdetails";
import SessionMonitor from "../components/SessionMonitor";
import Attendance from "../pages/attendance";
export default function RouteComponent(props) {

    return (<>
        <SessionMonitor includebypages={true} />
        <Routes>
            {/* {!storedCookie ? (
                <Route path="*" element={<Navigate to="/#" replace />} />
            ) : ( */}
            <>
                <Route exact path="/" element={<Dashboard setUserData={props.setUserData} />} />
                <Route path="/studentbehavior" element={<StudentBehaviour setUserData={props.setUserData} />} />
                <Route path="/staffdetails" element={<Staffdetails />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/StrengthWeakness" element={<StrengthWeakness setUserData={props.setUserData} />} />
                <Route path="/StudentPerformance" element={<StudentPerformance setUserData={props.setUserData} />} />
                <Route path="/schoolperformance" element={<Schoolperformance setUserData={props.setUserData} />} />
                <Route path="/enrollment" element={<Enrollment setUserData={props.setUserData} />} />
                {/* <Route path="/statebenchmarking" element={<StateBenchMarking setUserData={props.setUserData} />} /> */}
                {/* <Route path="/Annualplandashboard" element={<AnnualPlanDashboard setUserData={props.setUserData} />} /> */}
                <Route path="*" element={<PageNotFound />} />
            </>
            {/* )} */}
        </Routes>
    </>);
}
